import React from 'react';
import { connect } from 'react-redux';
import className from 'classnames/bind';
import styles from './index.pcss';
import properties from '../../../modules/ajio-util/properties';
import { getCurrentStore } from '../../selectors/metaData';

const cx = className.bind(styles);
const imageUrl: string = properties.getProperty('imageBaseUrl');

interface Iprops {
  products: string[];
  variant: 'desktop' | 'mobile';
  isLuxe: boolean;
  content: 'productCount' | 'videoDuration';
  duration: String;
}

const ProductsCountTag = (props: Iprops): JSX.Element | null => {
  const { products = [], variant = 'desktop', isLuxe, content, duration } = props;
  const items: number = products.length;
  if (content === 'productCount') {
    if (products.length) {
      return (
        <div className={cx('productsCountTag', variant, { luxeTag: isLuxe })}>
          <img
            className={cx(`${variant}Icon`)}
            src={`${imageUrl}/static/img/square.svg`}
            alt="Icon"
          />
          <div className={cx('text')}>{`${items} Products`}</div>
        </div>
      );
    }
    return null;
  }
  if (content === 'videoDuration') {
    if (duration) {
      return (
        <div className={cx('videoDurationTag', variant, { luxeTag: isLuxe })}>
          <img
            className={cx(`${variant}Icon`)}
            src={`${imageUrl}/static/img/video_duration_icon.svg`}
            alt="Video icon"
          />
          <div className={cx('text')}>{`${duration}`}</div>
        </div>
      );
    }
    return null;
  }
};

const mapStateToProps = state => {
  const store = getCurrentStore(state);
  const isLuxe = store === 'luxe';
  return {
    isLuxe
  };
};

export default connect(mapStateToProps)(ProductsCountTag);
